import { render, staticRenderFns } from "./ScaleProducts.vue?vue&type=template&id=722b94f4&scoped=true"
import script from "./ScaleProducts.vue?vue&type=script&lang=js"
export * from "./ScaleProducts.vue?vue&type=script&lang=js"
import style0 from "./ScaleProducts.vue?vue&type=style&index=0&id=722b94f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b94f4",
  null
  
)

export default component.exports